import { combineReducers } from 'redux';
import { reducer } from 'Reducers/newCollection';

export const TYPE = 'CENTRES-BOOKAPPOINTMENT';
export const CITIES_TYPE = 'CITIES-BOOKAPPOINTMENT';
export const TIME_SLOT_TYPE = 'TIME-SLOT-TYPES';
export const POST_APPOINTMENT_TYPE = 'POST-APPOINTMENT-TYPES';
export const EXISTING_APPOINTMENT_TYPE = 'EXISTING-APPOINTMENT-TYPES';
export const DISCLAIMER_TYPE = 'DISCLAIMER-TYPE';
export const TIME_CENTRE_FORCEFULLY_FETCH = 'TIME_CENTRE_FORCEFULLY_FETCH';
export const MAP_PAGE_REDUCER = {
    SET_INSPECTION_TYPE: 'SET_INSPECTION_TYPE',
    SET_USER_LAT_LNG: 'SET_USER_LAT_LNG',
    SET_USER_ADDRESS: 'SET_USER_ADDRESS',
    RESCHEDULE_FROM_MAP: 'RESCHEDULE_FROM_MAP',
    CURRENT_LOCATION_FETCHED: 'CURRENT_LOCATION_FETCHED',
    RESET_LOCATION_DETAILS: 'RESET_LOCATION_DETAILS',
    SET_SELECTED_LOCATION: 'SET_SELECTED_LOCATION',
    SET_CURRENT_ADDRESS: 'SET_CURRENT_ADDRESS',
    IS_LOCATION_CHANGED: 'IS_LOCATION_CHANGED',
    SET_SEARCH_SELECTED_LOCATION: 'SET_SEARCH_SELECTED_LOCATION'
};
export const CENTRE_TIMINGS_TYPE = 'CENTRE_TIMINGS';
export const SET_NON_SERVICEABLE_CENTER_SUGGESTION_DATA = 'SET_NON_SERVICEABLE_CENTER_SUGGESTION_DATA';
export const SET_CITYCODE = 'SET_CITYCODE';
export const SET_PLACE_ID = 'SET_PLACE_ID';

const initialStateCentres = {
    elements: {},
    collections: {},
    isFetching: {},
    isError: {},
    collectionMetadata: {},
    nonServiceableCenterSuggestion: []
};

const initialStateCMCCities = {
    isFetching: false,
    isError: false,
    data: {}
};

const initialTimeSlots = {
    isFetching: false,
    isError: false,
    data: {},
    fetchTimeSlotAndCentreForceFully: true
};

const initialPostAppointment = {
    isPosting: false,
    isError: false,
    data: {},
    nonServiceableCenterSuggestionExpVariant: undefined
};

const existingAppointmentsInitialStatus = {
    isFetching: false,
    isError: false,
    data: {}
};

const existingLocationDetails = {
    coordinates: null,
    addressLine1: '',
    inspectionTypeAvailable: 0,
    isRescheduleFromMapPage: false,
    selectedLocation: null,
    currentAddress: '',
    isLocationChanged: false,
    searchSelectedLocation: {}, // ON SELECTING AUTOCOMPLETE SEARCH LOCATION
    citycode: undefined
};

const initialStateCentreTimings = {
    isFetching: false,
    isError: false,
    data: {}
};

export function cmcCities(state = initialStateCMCCities, action) {
    switch (action.type) {
        case `REQUEST_${CITIES_TYPE}`:
            return {
                ...state,
                isFetching: true,
                isError: false
            };
        case `ERROR_${CITIES_TYPE}`:
            return {
                ...state,
                isError: true,
                isFetching: false
            };
        case `RECEIVE_${CITIES_TYPE}`:
            return {
                ...state,
                data: action.data.data,
                isFetching: false,
                isError: false
            };

        default:
            return state;
    }
}

export function disclaimer(state = initialStateCMCCities, action) {
    switch (action.type) {
        case `REQUEST_${DISCLAIMER_TYPE}`:
            return {
                ...state,
                isFetching: true,
                isError: false
            };
        case `ERROR_${DISCLAIMER_TYPE}`:
            return {
                ...state,
                isError: true,
                isFetching: false
            };
        case `RECEIVE_${DISCLAIMER_TYPE}`:
            return {
                ...state,
                data: action.data,
                isFetching: false,
                isError: false
            };

        default:
            return state;
    }
}

export function centres(state = initialStateCentres, action) {
    switch (action.type) {
        case SET_NON_SERVICEABLE_CENTER_SUGGESTION_DATA:
            return {
                ...state,
                nonServiceableCenterSuggestion: action.data
            };
        default:
            return reducer(state, action, TYPE, initialStateCentres);
    }
}

export function timeSlots(state = initialTimeSlots, action) {
    const { fetchTimeSlotAndCentreForceFully } = state;

    switch (action.type) {
        case `REQUEST_${TIME_SLOT_TYPE}`:
            return {
                isFetching: true,
                isError: false,
                data: {},
                fetchTimeSlotAndCentreForceFully
            };
        case `ERROR_${TIME_SLOT_TYPE}`:
            return {
                data: {},
                isError: true,
                isFetching: false,
                fetchTimeSlotAndCentreForceFully
            };
        case `RECEIVE_${TIME_SLOT_TYPE}`:
            return {
                data: action.data.data,
                isFetching: false,
                isError: false,
                fetchTimeSlotAndCentreForceFully
            };
        case `RESET_${TIME_SLOT_TYPE}`:
            return {
                data: {},
                isError: false,
                isFetching: false,
                fetchTimeSlotAndCentreForceFully
            };

        case TIME_CENTRE_FORCEFULLY_FETCH:
            return {
                ...state,
                fetchTimeSlotAndCentreForceFully: action.data
            };

        default:
            return state;
    }
}

export const postAppointment = (state = initialPostAppointment, action) => {
    switch (action.type) {
        case `REQUEST_${POST_APPOINTMENT_TYPE}`:
            return {
                ...state,
                isPosting: true,
                isError: false
            };
        case `ERROR_POST_${POST_APPOINTMENT_TYPE}`:
            return {
                ...state,
                isError: true,
                isPosting: false
            };
        case `RESPONSE_POST_${POST_APPOINTMENT_TYPE}`:
            return {
                ...state,
                data: action.data.data,
                error: action.data.error,
                isPosting: false,
                isError: false
            };

        case 'CLEAR-BOOKING':
            return initialPostAppointment;
        case 'SET_NON_SERVICEABLE_CENTER_SUGGESTION':
            return {
                ...state,
                nonServiceableCenterSuggestionExpVariant: action.variant
            };
        default:
            return state;
    }
};

export const existingAppointments = (state = existingAppointmentsInitialStatus, action) => {
    switch (action.type) {
        case `REQUEST_${EXISTING_APPOINTMENT_TYPE}`:
            return {
                ...state,
                isFetching: true,
                isError: false
            };
        case `ERROR_${EXISTING_APPOINTMENT_TYPE}`:
            return {
                ...state,
                isError: true,
                isFetching: false
            };

        case `RECEIVE_${EXISTING_APPOINTMENT_TYPE}`:
            return {
                ...state,
                data: action.data,
                isFetching: false,
                isError: false
            };

        default:
            return state;
    }
};

export const locationMapDetails = (state = existingLocationDetails, action) => {
    switch (action.type) {
        case MAP_PAGE_REDUCER.SET_INSPECTION_TYPE:
            return {
                ...state,
                inspectionTypeAvailable: action.inspectionType
            };
        case MAP_PAGE_REDUCER.SET_USER_LAT_LNG:
            return {
                ...state,
                coordinates: action.coordinates
            };
        case MAP_PAGE_REDUCER.SET_SELECTED_LOCATION:
            return {
                ...state,
                selectedLocation: action.selectedLocation
            };
        case MAP_PAGE_REDUCER.SET_CURRENT_ADDRESS:
            return {
                ...state,
                currentAddress: action.currentAddress
            };
        case MAP_PAGE_REDUCER.SET_USER_ADDRESS:
            return {
                ...state,
                addressLine1: action.address
            };
        case MAP_PAGE_REDUCER.RESCHEDULE_FROM_MAP:
            return {
                ...state,
                isRescheduleFromMapPage: action.value
            };
        case MAP_PAGE_REDUCER.CURRENT_LOCATION_FETCHED:
            return {
                ...state,
                fetchCurrentLocationOnce: action.value
            };
        case MAP_PAGE_REDUCER.RESET_LOCATION_DETAILS:
            return existingLocationDetails;
        case MAP_PAGE_REDUCER.IS_LOCATION_CHANGED:
            return {
                ...state,
                isLocationChanged: action.value
            };
        case MAP_PAGE_REDUCER.SET_SEARCH_SELECTED_LOCATION:
            return {
                ...state,
                searchSelectedLocation: action.location
            };
        case SET_CITYCODE:
            return {
                ...state,
                citycode: action.citycode
            };
        case SET_PLACE_ID:
            return {
                ...state,
                placeId: action.placeId
            };
        default:
            return state;
    }
};

export function centreTimings(state = initialStateCentreTimings, action) {
    const centreId = action?.params?.split('&')?.[0]?.split('=')?.[1];

    switch (action.type) {
        case `REQUEST_${CENTRE_TIMINGS_TYPE}`:
            return {
                ...state,
                isFetching: {
                    ...state.isFetching,
                    [centreId]: true
                },
                isError: {
                    ...state.isError,
                    [centreId]: false
                }
            };
        case `ERROR_${CENTRE_TIMINGS_TYPE}`:
            return {
                ...state,
                isFetching: {
                    ...state.isFetching,
                    [centreId]: false
                },
                isError: {
                    ...state.isError,
                    [centreId]: true
                }
            };
        case `RECEIVE_${CENTRE_TIMINGS_TYPE}`:
            return {
                ...state,
                data: {
                    ...state.data,
                    [centreId]: action.data.data
                },
                isFetching: {
                    ...state.isFetching,
                    [centreId]: false
                },
                isError: {
                    ...state.isError,
                    [centreId]: false
                }
            };

        default:
            return state;
    }
}

export default combineReducers({
    centres,
    cmcCities,
    timeSlots,
    postAppointment,
    existingAppointments,
    disclaimer,
    locationMapDetails,
    centreTimings
});
